import styled from '@emotion/styled';
import {colors} from 'ui/config';
import {TextSmall} from 'ui';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start',
  paddingBottom: 23,
  backgroundColor: colors.mauve,
});

export const Small = styled(TextSmall)({
  color: colors.white,
  textAlign: 'center',
  marginTop: 0,
  marginBottom: 16,
});

export const Gifts = styled('div')({
  display: 'flex',
  paddingLeft: 20,
  marginTop: 24,
  maxWidth: '100%',
  flexWrap: 'wrap',
  justifyContent: 'center',
});
